import { memo, useEffect, useMemo } from "react";
import { useMap } from "react-leaflet";
import { convertBitsToBytes } from "../../../../../utils/easyMaps/convertToBytes";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import L from "leaflet";
import * as ReactDOMServer from "react-dom/server";
import { useMapa } from "../../../../../contexts/mapaContext";
import { useOutletContext } from "react-router-dom";

export const PolylineCustom = memo(
  (
    {
      connection,
      positions,
      onClick = () => {},
      dbClick = () => {},
      variant = "trafego",
      radiusNodePixi,
      rulerMode,
    },
    key
  ) => {
    const { connectionsDataMap, elements, configurationMap } = useMapa();

    const connectionData = useMemo(
      () => connectionsDataMap.get(connection?.id) || {},
      [connectionsDataMap, connection?.id]
    );
    const { config } = useOutletContext();

    const animation = useMemo(
      () => connection?.config?.animation || "desativada",
      [connection]
    );

    const cor = useMemo(() => {
      if (variant === "trafego") {
        return (
          connectionsDataMap.get(connection?.id)?.corTraffic?.cor || "gray"
        );
      } else if (variant === "potencia") {
        return connectionsDataMap.get(connection?.id)?.corPower.cor || "gray";
      }
    }, [connectionsDataMap, connection?.id, variant]);

    const host = useMemo(
      () => elements?.get(connection?.referenceId)?.titulo || "",
      [elements, connection?.referenceId]
    );

    const theme = useTheme();
    const styles = {
      fontPopup: {
        margin: "0px",
        fontSize: "12px",
        fontWeight: 500,
        color: theme.palette.color.textEasyMaps,
      },
      colorTextLayer: {
        color: theme.palette.text.primary,
        fontWeight: 600,
      },
      titlePopup: {
        margin: "0px",
        fontSize: "12px",
        fontWeight: 500,
        color: theme.palette.color.textEasyMaps,
        width: "100%",
        textAlign: "center",

        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 2, // Limite de 2 linhas
        WebkitBoxOrient: "vertical",
      },
      boxInfo: {
        display: "flex",
        flexDirection: "row",
        gap: "3px",
      },
      stackPopup: {
        width: "200px",
      },
    };
    let animationOp = {
      pontilhada: "1, 10",
      tracejada: "8, 13",
      desativada: null,
    };
    const map = useMap();

    const Content = () => {
      if (variant == "trafego") {
        const outPutTrafficData = convertBitsToBytes(
          connectionData?.tx_traffic
        );
        const inPutTrafficData = convertBitsToBytes(connectionData?.rx_traffic);

        return (
          <Stack key={key} style={styles.stackPopup}>
            <Typography style={styles.titlePopup}>{host}</Typography>
            <Typography
              style={{ ...styles.titlePopup, ...styles.colorTextLayer }}
            >
              {"[ " + (connectionData?.interface || "Desconhecido") + " ]"}
            </Typography>
            <br />
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                TX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {outPutTrafficData.valor}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  {outPutTrafficData.unidade}
                </Typography>
              </Box>
            </Box>
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                RX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {inPutTrafficData.valor}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  {inPutTrafficData.unidade}
                </Typography>
              </Box>
            </Box>
          </Stack>
        );
      } else if (variant == "potencia") {
        return (
          <Stack key={key} style={styles.stackPopup}>
            <Typography style={styles.titlePopup}>{host}</Typography>
            <Typography
              style={{ ...styles.titlePopup, ...styles.colorTextLayer }}
            >
              {"[ " + (connectionData?.interface || "Desconhecido") + " ]"}
            </Typography>
            <br />
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                TX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {connectionData?.tx_power}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  dBm
                </Typography>
              </Box>
            </Box>
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                RX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {connectionData?.rx_power}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  dBm
                </Typography>
              </Box>
            </Box>
          </Stack>
        );
      } else return null;
    };

    //var popup = L.popup();
    var popup = L.tooltip([0, 0], {
      permanent: false,
      direction: "top",
      offset: [0, -5],
      opacity: 0.9,
    });

    useEffect(() => {
      if (!positions || positions.length < 2 || !map) return;

      const latlngs = positions.map((pos) => L.latLng(pos[0], pos[1]));

      const shrinkLine = (latlngArray) => {
        if (latlngArray.length < 2) return latlngArray;

        const points = latlngArray.map((p) => map.latLngToContainerPoint(p));
        const newPoints = [...points];

        const movePoint = (p, dir, distance) =>
          L.point(p.x + dir.x * distance, p.y + dir.y * distance);

        const p1 = points[0];
        const p2 = points[1];
        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        const len = Math.sqrt(dx * dx + dy * dy);

        if (len > 0) {
          const dir = { x: dx / len, y: dy / len };
          newPoints[0] = movePoint(p1, dir, radiusNodePixi);
        }

        const pn = points[points.length - 1];
        const pn_1 = points[points.length - 2];
        const dxEnd = pn.x - pn_1.x;
        const dyEnd = pn.y - pn_1.y;
        const lenn = Math.sqrt(dxEnd * dxEnd + dyEnd * dyEnd);

        if (lenn > 0) {
          const dir = { x: dxEnd / lenn, y: dyEnd / lenn };
          newPoints[newPoints.length - 1] = movePoint(pn, dir, -radiusNodePixi);
        }

        return newPoints.map((p) => map.containerPointToLatLng(p));
      };

      const adjustedPositions = shrinkLine(latlngs, 15);
      // Criação das linhas principais
      const line = L.polyline(adjustedPositions, {
        // a linha tende a não renderizar na animção, para poupar reprocesso
        color: cor,
        weight: 3,
        dashArray: animationOp[animation],
        //renderer: L.svg(),
      }).addTo(map);

      const lineBase = L.polyline(adjustedPositions, {
        color: "transparent",
        weight: 5,
        //renderer: L.svg(),
      }).addTo(map);

      // Configuração do popup

      popup.setContent(ReactDOMServer.renderToString(<Content />));

      // Event listeners

      if (!rulerMode) {
        lineBase.on("click", onClick);
        lineBase.on("dblclick", dbClick);
      }

      lineBase.on("mouseover mousemove", (e) => {
        popup.setLatLng(e.latlng).openOn(map);
      });
      lineBase.on("mouseout mouseleave", () => {
        map.removeLayer(popup);
      });

      // Animação
      let offset = 0;
      let currentColors = cor;
      let lastChangeTime = 0; // Marca de tempo para mudanças de cor
      let animationFrameId; // Identificador da animação

      const animateDown = (timestamp) => {
        if (timestamp - lastChangeTime > 400) {
          currentColors =
            currentColors !== theme.palette.enlaces.p90.main
              ? theme.palette.enlaces.p90.main
              : theme.palette.enlaces.offline.main;
          lastChangeTime = timestamp;
        }
        line.setStyle({ color: currentColors });
        animationFrameId = requestAnimationFrame(animateDown);
      };

      const animate = (step) => {
        offset -= step;
        line.setStyle({ dashOffset: offset });
        animationFrameId = requestAnimationFrame(() => animate(step));
      };

      // Controle da animação
      if (connectionData) {
        if (connectionData?.isDown === true) {
          animationFrameId = requestAnimationFrame(animateDown);
        } else if (
          animationOp[animation] !== null &&
          configurationMap?.configuracoes?.animacao?.linha !== false
        ) {
          const isTrafficInvalid =
            variant === "trafego" &&
            !connectionData?.tx_traffic &&
            !connectionData?.rx_traffic;

          if (isTrafficInvalid) {
            animationFrameId = requestAnimationFrame(() => animate(0));
          } else {
            animationFrameId = requestAnimationFrame(() => animate(0.5));
          }
        }
      }

      // Cleanup
      return () => {
        // Cancela animações

        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
        map.removeLayer(lineBase);
        map.removeLayer(line);
        map.removeLayer(popup);

        // Remove listeners
        lineBase.off("click", onClick);
        lineBase.off("dblclick", dbClick);
        lineBase.off("mouseover mousemove");
        lineBase.off("mouseout mouseleave");
      };
    }, [
      key,
      map,
      positions,
      animation,
      config,
      connectionData,
      configurationMap,
      variant,
      radiusNodePixi,
    ]);

    return null;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.positions === nextProps.positions &&
      prevProps.darkMode === nextProps.darkMode &&
      prevProps.host === nextProps.host &&
      prevProps.animation === nextProps.animation &&
      prevProps.percent === nextProps.percent &&
      prevProps.isDown === nextProps.isDown &&
      prevProps.variant === nextProps.variant &&
      prevProps.configurationMap?.configuracoes?.animacao?.linha ===
        nextProps?.configurationMap?.configuracoes?.animacao?.linha
    );
  }
);

export function PolylineSimple(
  {
    positions = [],
    dbClick = () => {},
    color = null,
    onClick = () => {},
    shrinkEdges,
    radiusNodePixi = 0,
    rulerMode,
  },
  key
) {
  const theme = useTheme();
  const map = useMap();
  const { config } = useOutletContext();
  useEffect(() => {
    if (!positions || positions.length < 2 || !map) return;

    const latlngs = positions.map((pos) => L.latLng(pos[0], pos[1]));

    const shrinkLine = (latlngArray, mode) => {
      if (latlngArray.length < 2) {
        return latlngArray;
      }

      const points = latlngArray.map((p) => map.latLngToContainerPoint(p));
      const newPoints = [...points];

      const movePoint = (p, dir, distance) =>
        L.point(p.x + dir.x * distance, p.y + dir.y * distance);

      if (mode === "both" || mode === "start") {
        const p1 = points[0];
        const p2 = points[1];

        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        const len = Math.sqrt(dx * dx + dy * dy);
        if (len !== 0) {
          const dir = { x: dx / len, y: dy / len };
          newPoints[0] = movePoint(p1, dir, radiusNodePixi);
        }
      }

      if (mode === "both" || mode === "end") {
        const pn = points[points.length - 1];
        const pn_1 = points[points.length - 2];

        const dx = pn.x - pn_1.x;
        const dy = pn.y - pn_1.y;
        const len = Math.sqrt(dx * dx + dy * dy);
        if (len !== 0) {
          const dir = { x: dx / len, y: dy / len };
          newPoints[newPoints.length - 1] = movePoint(pn, dir, -radiusNodePixi);
        }
      }

      return newPoints.map((p) => map.containerPointToLatLng(p));
    };
    const adjustedPositions = shrinkLine(latlngs, shrinkEdges);

    const line = L.polyline(adjustedPositions, {
      color: color ? color : theme.palette.enlaces.offline.main,
      weight: 3.5,
    }).addTo(map);

    if (!rulerMode) {
      line.on("dblclick", dbClick);
      line.on("click", onClick);
    }

    return () => {
      map.removeLayer(line);
      line.off("click", onClick);
      line.off("dblclick", dbClick);
    };
  }, [
    positions,
    theme,
    dbClick,
    key,
    color,
    map,
    config,
    radiusNodePixi,
    shrinkEdges,
  ]);

  return null;
}
